var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _vm._m(0),
      _c("InputFilter", {
        staticClass: "pl-6 block w-full h-12",
        attrs: {
          placeholder: "Search by name",
          debounceTime: _vm.debounceTime,
          inputClass: _vm.inputClass,
        },
        on: { input: _vm.search },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "absolute left-0 inset-y-0 flex items-center h-12" },
      [
        _c("span", {
          staticClass:
            "mdi ml-2 pb-1 text-gray-400 text-xl mdi-magnify hover:text-primary-500",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }